import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import "./language/i18n";
import "@myloc/myloc-gui/dist/styles/css-reset.css";
import "./index.scss";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
